import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants, links, formatPrice } from 'common/helpers'
import { injectIntl, FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'

import messages from './messages'
import s from './NeedPaymentDataModal.scss'


class NeedPaymentDataModal extends Component {

  static propTypes = {
    intl: PropTypes.object, // @injectIntl
    data: PropTypes.shape({
      item: PropTypes.object.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    name: constants.modals.premiumProducts.NeedPaymentData,
  }

  redirect = () => {
    const { name, data: { item } } = this.props

    actions.models.modals.close(name)
    actions.view.postponedPremiumProduct.setProduct(item)
    actions.models.router.push(links.profile.billingAndShipping)
  }

  render() {
    const { name, intl, data: { item: { upchargePrice = 1000 } = {} } } = this.props

    const price = formatPrice(upchargePrice, true, false, 0)
    const title = intl.formatMessage(messages.title, { price })

    return (
      <Modal {...{ name, title, titleUppercase: true }}>
        <FormattedMessage className={s.text} tag="div" {...messages.text} values={{ price }} />
        <ModalFooter>
          <Button className={s.button} title={messages.buttonTitle} brand lg onClick={this.redirect} />
        </ModalFooter>
      </Modal>
    )
  }
}


export default injectIntl(NeedPaymentDataModal)
